import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import { ItemInquiryInputKind, ItemInquiryInputPattern } from 'types/api';
import { useMutationInquiryTemplate } from '../graphQL/hooks/useMutationInquiryTemplate';
import { Inquiries, InquiryTemplateParamInput } from '../graphQL/types';

export const useInquiriesHooks = () => {
  const { handleCreateInquiryTemplate, handleUpdateInquiryTemplate } =
    useMutationInquiryTemplate();

  const [inquiryTemplate, setInquiryTemplate] =
    useState<InquiryTemplateParamInput>({
      name: '',
      activated: true,
      inquiries: [],
    });
  const [inputPattern, setInputPattern] = useState<ItemInquiryInputPattern>(
    ItemInquiryInputPattern.PER_ITEM_COUNT,
  );
  const [inquiries, setInquiries] = useState<Inquiries>({
    title: '',
    inputKind: ItemInquiryInputKind.TEXT,
    inputPattern,
    required: false,
    activated: true,
    items: [],
  });

  const handleSetInquiries = (key: string, value: any) => {
    setInquiries({ ...inquiries, [key]: value });
  };

  const handleSetItemInputPattern = (pattern: ItemInquiryInputPattern) => {
    const copyInquiryTemplate = cloneDeep(inquiryTemplate);

    copyInquiryTemplate.inquiries.forEach(item => {
      item.inputPattern = pattern;
    });

    setInquiryTemplate(copyInquiryTemplate);
    setInputPattern(pattern);
    handleSetInquiries('inputPattern', pattern);
  };

  const handleSetInquiryTemplate = (key: string, value: any) => {
    setInquiryTemplate({ ...inquiryTemplate, [key]: value });
  };

  /*
    삭제/수정 핸들러는 변경이 반영된 템플릿을 반환한다.
    setState는 다음 렌더에 반영되므로, 같은 이벤트에서 저장 뮤테이션을 보낼 때는
    반환값을 사용해야 수정 전 데이터가 서버로 전송되는 것을 막을 수 있다.
  */
  const handleDeleteInquiryTemplate = (filterIdx: number, id?: string) => {
    const filterItem = inquiryTemplate.inquiries.filter((item, idx) =>
      id ? item.id !== id : idx !== filterIdx,
    );

    const nextInquiryTemplate = { ...inquiryTemplate, inquiries: filterItem };

    setInquiryTemplate(nextInquiryTemplate);

    return nextInquiryTemplate;
  };

  const handleModifyInquiryTemplate = (modifyIndex: number) => {
    const copyInquiryTemplate = cloneDeep(inquiryTemplate);

    copyInquiryTemplate.inquiries[modifyIndex] = inquiries;

    setInquiryTemplate(copyInquiryTemplate);

    return copyInquiryTemplate;
  };

  const handleResetInquiries = () => {
    setInquiries({
      title: '',
      inputKind: ItemInquiryInputKind.TEXT,
      inputPattern,
      required: false,
      activated: true,
      items: [],
    });
  };

  return {
    inquiryTemplate,
    inquiries,
    inputPattern,
    setInputPattern,
    setInquiries,
    setInquiryTemplate,
    handleSetInquiries,
    handleSetInquiryTemplate,
    handleResetInquiries,
    handleModifyInquiryTemplate,
    handleCreateInquiryTemplate,
    handleDeleteInquiryTemplate,
    handleUpdateInquiryTemplate,
    handleSetItemInputPattern,
  };
};
